// frontend/src/OnboardingRefreshPage.js
function OnboardingRefreshPage() {
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h2>⚠️ Stripe onboarding was interrupted</h2>
      <p>You can try again from your profile page.</p>
    </div>
  );
}

export default OnboardingRefreshPage;

